import { render, staticRenderFns } from "./DetailsItemHistoricLimit.vue?vue&type=template&id=7bec4518"
import script from "./DetailsItemHistoricLimit.vue?vue&type=script&lang=js"
export * from "./DetailsItemHistoricLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports